<script>
import baseMixin from '@/mixins/baseMixin'
import HttpStatusCodes from '@/constants/api/HttpStatusCodes'
import EmptyStateBlock from '@/components/general/empty-state-block.vue'

export default {
  name: 'ClientBullhornErrorBlock',
  components: { EmptyStateBlock },
  mixins: [baseMixin],
  props: {
    clientId: {
      type: Number,
      default: null,
    },
    error: {
      type: Object,
      default: () => {
        return {
          code: 'unknown_error',
          status: null,
          message: '',
        }
      },
    },
  },
  computed: {
    httpResponseStatus() {
      return this.error.status
    },
    errorCode() {
      return this.error.code
    },
    errorMessage() {
      if (this.error.message) return this.error.message

      switch (this.httpResponseStatus) {
        case HttpStatusCodes.NotFound:
          return this.$t('client.bullhorn.error.notFound', [this.clientId])
        case HttpStatusCodes.Unauthorized:
        case HttpStatusCodes.Forbidden:
          return this.$t('client.bullhorn.error.unauth')
        default:
          return this.$t('client.bullhorn.error.generic', [this.clientId])
      }
    },
  },
}
</script>

<template>
  <EmptyStateBlock title="Unable to load bullhorn data">
    <template v-slot:description>
      <p class="mb-0">{{ errorMessage }} ({{ httpResponseStatus }})</p>
      <p class="caption">
        Error code: <code>{{ errorCode }}</code></p
      >
    </template>
    <template v-slot:button>
      <div class="mt-4">
        <v-btn
          data-testid="failure-to-load-retry-btn"
          color="primary"
          class="white--text"
          depressed
          large
          @click="$emit('retry')"
        >
          <v-icon left> mdi-refresh </v-icon>
          {{ $t('general.retry') }}
        </v-btn>
      </div>
    </template>
  </EmptyStateBlock>
</template>
